import { jd_employee_creation } from '@prisma/client';
import { Reducer } from '../interface';

export const setEmployeeMap: Reducer<Record<number, jd_employee_creation & { role_id: number }>> = (state, { payload }) => {
  state.employeeMap = payload;
};
